<template>
  <div
    class="skeleton-loading__wrapper">
    <div
      v-for="item in items"
      :key="`${item}-skeleton`"
      :style="{
        height: computedHeight
      }"
      class="skeleton-loading rounded my-2"
    />
  </div>
</template>

<script>
// @flow
export default {
  name: 'SmartSkeletonLoading',
  props: {
    height: {
      type: Number,
      default: 1
    },
    items: {
      type: Number,
      default: 1
    }
  },
  computed: {
    computedHeight() {
      return `${this.height / 2}rem`;
    }
  }
};
</script>

<style lang="scss">
$base-color: rgb(245, 245, 245);
$shine-color: rgba(229,229,229,0.8);
$animation-duration: 0.3s;

@keyframes load {
  from {
    background: $base-color;
  }
  to {
    background: $shine-color;
  }
}

.skeleton-loading {
  background: $base-color;
  position: relative;
  overflow: hidden;
  animation: load $animation-duration ease-in-out infinite alternate;
}
</style>
